import getUniqueNameFromTrade from './get-unique-name-from-trade';

const hasUniqueName = (uniqueName = '', arrayToCheck = []) =>
  arrayToCheck.some(
    item =>
      getUniqueNameFromTrade(item).toLowerCase() === uniqueName.toLowerCase(),
  );

export default hasUniqueName;
